import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  CheckContainedFill,
  Mail01,
  XCircleContainedFill,
} from 'lib/lucky-x-icons-2';
import { useUserInfo } from 'lib/user';
import { setInputEmail, setValidEmail } from 'store/features/userSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setEmail } from 'api/user_profile/user_profile_set_email';
import { successMsg } from '@/components/PageElement/SuccessMessage';
import { errMsg } from '@/components/PageElement/ErrorMessage';
import classNames from 'classnames';

interface IEmailInputprops {
  modalBg?: boolean;
}

const EmailInput: React.FC<IEmailInputprops> = ({ modalBg }) => {
  const reg = useMemo(() => {
    return /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
  }, []);
  const dispatch = useAppDispatch();
  const [value, setValue] = useState('');
  const { email } = useUserInfo();
  const [isFocusEmail, setIsFocusEmail] = useState(false);
  const { validEmail, antiCode } = useAppSelector((state) => state.user);

  useEffect(() => {
    if (!!email) {
      dispatch(setInputEmail(email));
      dispatch(setValidEmail(1));
      setValue(email);
      localStorage.setItem('email', email);
    } else {
      setValue('');
      localStorage.removeItem('email');
    }
  }, [dispatch, email]);

  const emailVerifyIcon = useCallback(() => {
    if (validEmail === 0) {
      return <Mail01 size={24} className="text-neutral-500" />;
    } else if (validEmail === 1) {
      return <CheckContainedFill size={24} className="text-primary-500" />;
    } else if (validEmail === -1) {
      return <XCircleContainedFill size={24} className="text-warn-300" />;
    }
  }, [validEmail]);

  const handleChangeEmail = (e: any) => {
    dispatch(setValidEmail(0));
    dispatch(setInputEmail(e.target.value));
    setValue(e.target.value);
  };

  const handleVerifyEmail = useCallback(async () => {
    setIsFocusEmail(false);
    if (value === '') {
      return;
    }
    if (reg.test(value)) {
      dispatch(setValidEmail(1));
      if (value !== localStorage.getItem('email')) {
        const res = await setEmail(value, antiCode);
        if (res?.code === 0) {
          successMsg('Update Email successful');
          dispatch(setInputEmail(value));
          localStorage.setItem('email', value);
        } else {
          errMsg(res?.msg);
        }
      }
    } else {
      dispatch(setValidEmail(-1));
    }
  }, [antiCode, dispatch, reg, value]);

  return (
    <div className="relative mb-5 flex items-center gap-2 rounded-2xl border border-neutral-600 px-5 py-6">
      {emailVerifyIcon()}
      <input
        type="text"
        className={classNames(
          'peer w-full border-none  text-white placeholder:text-neutral-500 placeholder:peer-focus:hidden',
          {
            '!bg-neutral-1000': !modalBg,
            '!bg-neutral-900': modalBg,
          }
        )}
        placeholder={isFocusEmail ? '' : 'Email address'}
        onChange={handleChangeEmail}
        value={value}
        onBlur={handleVerifyEmail}
        onFocus={() => {
          setIsFocusEmail(true);
        }}
      />
      <div
        className={classNames(
          'absolute -top-3 left-7 hidden px-2 py-1 text-center text-sm font-normal  text-white peer-focus:block',
          {
            '!bg-neutral-1000': !modalBg,
            '!bg-neutral-900': modalBg,
          }
        )}
      >
        Email address
      </div>
    </div>
  );
};

export default EmailInput;
